import {
    GET_ALL_MY_BASKET_STARTED,
    GET_ALL_MY_BASKET_SUCCESS,
    GET_ALL_MY_BASKET_FAILURE
  } from '../constants/auth.constant';
  
  const initialState = {
    loading: false,
    getAllBasketInfo: [],
    error: null
  };
  
  export default function getAllMyBasketReducer(state = initialState, action) {
    switch (action.type) {
      case GET_ALL_MY_BASKET_STARTED:
        return {
          ...state,
          loading: true
        };
      case GET_ALL_MY_BASKET_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          getAllBasketInfo: {...state.getAllBasketInfo, ...action.payload}
        };
      case GET_ALL_MY_BASKET_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error
        };
      default:
        return state;
    }
  }